import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-212729e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick", "onKeypress"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Distribution", -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Not Connected ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner_ios = _resolveComponent("q-spinner-ios")!
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_board_lookup = _resolveComponent("board-lookup")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "text-white" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_btn, {
        class: "q-mr-sm",
        flat: "",
        dense: "",
        round: "",
        icon: "mdi-menu",
        "aria-label": "Menu",
        onClick: _ctx.toggleSidebar
      }, null, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_q_separator, {
        dark: "",
        vertical: "",
        inset: ""
      }),
      _createVNode(_component_q_toolbar_title, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: { name: 'dashboard' },
            custom: ""
          }, {
            default: _withCtx(({ navigate }) => [
              _createElementVNode("a", {
                href: "/",
                style: {"cursor":"pointer"},
                class: "toolbar-title",
                onClick: navigate,
                onKeypress: _withKeys(navigate, ["enter"])
              }, _hoisted_3, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1)
            ]),
            _: 1 /* STABLE */
          }),
          _createTextVNode(" / " + _toDisplayString(_ctx.pageTitle), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode("    <q-space />"),
      (!_ctx.isConnected)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: "mdi-connection",
            size: "xs",
            class: "q-pr-lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      (_ctx.isConnected && _ctx.loading)
        ? (_openBlock(), _createBlock(_component_q_spinner_ios, {
            key: 1,
            class: "on-left"
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_q_tabs, {
        "inline-label": "",
        shrink: "",
        stretch: "",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_separator, {
            dark: "",
            vertical: ""
          }),
          _createVNode(_component_q_route_tab, {
            label: "Postings",
            to: { name: 'postings' },
            exact: ""
          }),
          _createCommentVNode("      <q-separator dark vertical />"),
          _createCommentVNode("      <q-route-tab label=\"Tasks\" :to=\"{ name: 'tasks' }\" exact />"),
          _createVNode(_component_q_separator, {
            dark: "",
            vertical: ""
          }),
          _createVNode(_component_q_route_tab, {
            label: "Boards",
            to: { name: 'board-actions' },
            icon: "mdi-format-list-checks",
            exact: ""
          }),
          _createVNode(_component_q_separator, {
            dark: "",
            vertical: "",
            inset: ""
          }),
          _createVNode(_component_board_lookup, { label: "Go To" })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}